import { useRequiredContext } from "@redotech/react-util/context";
import CalculatorIcon from "@redotech/redo-icons/calculator.svg";
import CalculatorFilledIcon from "@redotech/redo-icons/calculator_filled.svg";
import { useHasPermission } from "@redotech/redo-merchant-app-common/auth/permissions-context";
import { MerchantRoutesContext } from "@redotech/redo-merchant-app-common/merchant-routes";
import { OrderManagementPermissions } from "@redotech/redo-model/permissions";
import { RedoSecondaryNavItem } from "@redotech/redo-web/arbiter-components/navigation/secondary/redo-secondary-nav-item";
import { memo } from "react";

export const TariffCalculatorItem = memo(function TariffCalculatorItem() {
  const routes = useRequiredContext(MerchantRoutesContext);

  const hasPermissionToViewItem = useHasPermission(
    OrderManagementPermissions.VIEW_ORDER,
    OrderManagementPermissions.VIEW_RETURN,
    OrderManagementPermissions.MANAGE_WARRANTY,
    OrderManagementPermissions.MANAGE_PACKAGE_PROTECTION_CLAIM,
    OrderManagementPermissions.MANAGE_SHIPMENTS,
  );

  if (!hasPermissionToViewItem) {
    return null;
  }

  return (
    <RedoSecondaryNavItem
      action={{ type: "link", href: routes.tariffCalculatorHref }}
      beta
      FilledIcon={CalculatorFilledIcon}
      friendlyName="Tariff Calculator"
      id="tariff-calculator"
      UnfilledIcon={CalculatorIcon}
    />
  );
});
